module.exports = __webpack_public_path__ + "img/b1e20f1f47cc2d382d15ed184159e4f5.d7724c4c.jpg";